import React from 'react'

export default ({
  className = ''
}) => (
<svg className={className} xmlns="http://www.w3.org/2000/svg" width="51.25" height="66.625" viewBox="0 0 51.25 66.625"><path d="M15.375-64.062V2.563h51.25V-47.166l-.721-.8L50.529-63.342l-.8-.721ZM20.5-58.937H46.125v15.375H61.5v41h-41Zm30.75,3.684,6.566,6.566H51.25Z" transform="translate(-15.375 64.063)"/></svg>
)
